module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "prologue",
      "id": "_idContainer",
      "role": "doc-prologue"
    }
  }, [_c('h1', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("PROLOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("RAKON")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("K")]), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("ONSTANTINOU")]), _vm._v(" "), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("LOOKED")]), _vm._v(" around him, unable to hide the disgust which swamped his body like a dank, dark tide. But hot on the heels of disgust came regret, and then guilt. Regret that he couldn’t have done something sooner and guilt that he couldn’t have prevented this terrible outcome.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But the trigger to these grisly events had been pulled a long time ago and he couldn’t control everything, no matter how much he had spent his whole life trying to do just that. Sometimes control just slipped beyond your grasp and there was nothing you could do about it. His brother had gone now and so had the woman he’d married—the sordid paraphernalia strewn around the room the last testimony to their degenerate lifestyle.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But life went on.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Life "), _c('i', [_vm._v("had")]), _vm._v(" to go on.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As if to confirm that indisputable fact, he heard an unfamiliar cry coming from an adjoining room, quickly followed by a voice and the sound of footsteps.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Drakon?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He glanced up at his business partner’s face as she walked in from the adjoining room. Gingerly, she walked towards him, clearly uncomfortable as she carried her precious cargo—as if unsure just what to do next. "), _c('i', [_vm._v("Join the club,")]), _vm._v(" thought Drakon grimly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Are you ready, Drakon?’ she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wanted to shake his head. To tell her he wasn’t prepared for this latest responsibility which had come slamming at him like a weighted curve ball. To protest that he’d done enough of shouldering other people’s burdens and their problems and he needed a break. But that was impossible. He could do this. He "), _c('i', [_vm._v("would")]), _vm._v(" do this. He just hadn’t quite worked out how.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He needed a woman, that was for sure, but a quick flick through his memory bank of females who would be willing to do pretty much anything he asked of them failed to come up with anyone remotely suitable.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And then, as if in answer to the turmoil of his thoughts, a face unexpectedly swam into his mind. A face with soft blue eyes the colour of the bluebells which had grown beneath the trees in those long-ago English springs, in the heady days before he’d discovered how much his father liked hookers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Forcing his mind back to the present, he thought about the face again. Not a beautiful face but a kindly one. He felt a faint beat of remembered desire, but far stronger still was his sudden sense of purpose as he allowed his mind to linger on Lucy Phillips for the first time in many months and his eyes narrowed speculatively. Maybe fate was cleverer than he’d imagined. Maybe the answer had been staring him in the face all this time.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("‘Neh,’")]), _vm._v(" he said, his harsh Greek accent echoing around the marble-floored villa. ‘I’m ready.’")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e064fd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 78
// module chunks = 0